export default "__VITE_ASSET__eXo6sjxP__"